<template>
  <button
    v-if="getAction(exam).visible"
    class="btn-small u-center u-pull-right"
    v-bind:class="getAction(exam).class"
  >
    <router-link :to="{ name: 'exam-detail', params: { id: exam.id } }">
      {{ getAction(exam).label }}
    </router-link>
  </button>
</template>
<style></style>
<script>
import { mapGetters } from "vuex";

export default {
  name: "exam-action-button",
  props: ["exam"],
  computed: {
    ...mapGetters("auth", ["userProfile", "permissions"])
  },
  methods: {
    getAction: function(exam) {
      var result = { visible: false, label: "", class: "" };
      // User can complete their own exams that aren't closed
      const _is_candidate = exam.candidate.id == this.userProfile.id;
      const _is_supervisor = exam.supervisor.id == this.userProfile.id;
      const _is_involved = _is_candidate || _is_supervisor;
      const _has_view_perm = this.permissions.includes("exams.view_exam");
      if (_is_candidate && !exam.is_closed) {
        // Complete own exam if involved and exam is not yet complete
        result.visible = true;
        result.label = "Complete";
        result.class = "btn-primary";
      } else if (exam.is_closed && exam.result.status == -1 && _is_supervisor) {
        // Supervisor can Mark any exam that is closed if there isn't a result
        result.visible = true;
        result.label = "Mark";
        result.class = "btn-dark";
      } else if (_is_involved || (_has_view_perm && exam.is_closed)) {
        // View any exam the user is involved with.
        // Also, all instructors/examiners (etc.) can view all closed exams
        result.visible = true;
        result.label = "View";
        result.class = "btn-info outline";
      }
      return result;
    }
  }
};
</script>
